import { createSvgIcon } from '@material-ui/core';

export const CueIcon = createSvgIcon(
  <svg
    viewBox="0 0 48 48"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M28.3333 43L21.3333 36L28.3333 29L29.9958 30.6625L24.6292 36.0291L29.9667 41.3666L28.3333 43ZM37.6667 43L36.0042 41.3375L41.3708 35.9708L36.0333 30.6333L37.6667 29L44.6667 36L37.6667 43Z"
      fill="currentColor"
    />
    <path
      d="M4.9519 4.99584C5.5614 4.35821 6.38805 4 7.25 4H20.25L30 14.2V24H26.75V15.9H18.625V7.4H7.25V34.6H18V38H7.25C6.38805 38 5.5614 37.6418 4.9519 37.0042C4.34241 36.3665 4 35.5017 4 34.6V7.4C4 6.49826 4.34241 5.63346 4.9519 4.99584Z"
      fill="currentColor"
    />
    <path d="M18 27.8V31.2H10.5V27.8H18Z" fill="currentColor" />
    <path d="M23.5 24H18V24.4H10.5V21H23.5V24Z" fill="currentColor" />
  </svg>,
  'CueIcon',
);
